export const Actions = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  SIDEBAR_EXPAND: "SIDEBAR_EXPAND",
  SELECTED_BETSLIP: "SELECTED_BETSLIP",
  REMOVE_SELECTED_BETSLIP: "REMOVE_SELECTED_BETSLIP",
  REMOVE_ALL_BETSLIP: "REMOVE_ALL_BETSLIP",
  SET_GAME: "SET_GAME",
  CLEAR_GAME: "CLEAR_GAME",
  LEAGUE_GAMES: "LEAGUE_GAMES",
  SELECTED_USER: "SELECTED_USER",
  CLEAR_SELECTED: "CLEAR_SELECTED"
};
export default {};
